import React, { useState, useEffect } from 'react';
import { Download, Calendar, X, Sparkles } from 'lucide-react';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import styles from './CalendarPage.module.css';
import januaryImg from '../../images/jan.jpg';
import februaryImg from '../../images/feb.jpg';
import marchImg from '../../images/march.jpg';
import aprilImg from '../../images/april.jpg';
import mayImg from '../../images/may.jpg';
import juneImg from '../../images/june.jpg';
import julyImg from '../../images/july.jpg';
import augustImg from '../../images/august.jpg';
import septemberImg from '../../images/september.jpg';
import octoberImg from '../../images/october.jpg';
import novemberImg from '../../images/November.jpg';
import decemberImg from '../../images/December.jpg';
import calendarPDF from '../../images/Calender.pdf';

const CalendarPage = () => {
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [particles, setParticles] = useState([]);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [menuOpen, setMenuOpen] = useState(false);
  const [mode, setMode] = useState('graphic');
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    // Generate floating particles
    const newParticles = Array.from({ length: 30 }, (_, i) => ({
      id: i,
      x: Math.random() * 100,
      y: Math.random() * 100,
      size: Math.random() * 4 + 2,
      duration: Math.random() * 10 + 15,
      delay: Math.random() * 5
    }));
    setParticles(newParticles);
  }, []);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const handleMouseMove = (e) => {
      setMousePosition({
        x: (e.clientX / window.innerWidth) * 100,
        y: (e.clientY / window.innerHeight) * 100
      });
    };
    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);



  const months = [
    { name: 'January', image: januaryImg, color: '#3b82f6' },
    { name: 'February', image: februaryImg, color: '#ec4899' },
    { name: 'March', image: marchImg, color: '#10b981' },
    { name: 'April', image: aprilImg, color: '#f59e0b' },
    { name: 'May', image: mayImg, color: '#8b5cf6' },
    { name: 'June', image: juneImg, color: '#06b6d4' },
    { name: 'July', image: julyImg, color: '#ef4444' },
    { name: 'August', image: augustImg, color: '#f97316' },
    { name: 'September', image: septemberImg, color: '#14b8a6' },
    { name: 'October', image: octoberImg, color: '#a855f7' },
    { name: 'November', image: novemberImg, color: '#84cc16' },
    { name: 'December', image: decemberImg, color: '#6366f1' }
  ];

  const handleDownloadPDF = () => {
    const link = document.createElement('a');
    link.href = calendarPDF;
    link.download = 'Custom-Calendar-2026-Complete.pdf';
    link.click();
  };

  const handleDownloadImage = (month) => {
    const link = document.createElement('a');
    link.href = month.image;
    link.download = `${month.name}-2026.jpg`;
    link.click();
  };

  return (
    <>
      {!selectedMonth && <Header mode={mode} setMode={setMode} menuOpen={menuOpen} setMenuOpen={setMenuOpen} scrolled={scrolled} />}
      <div className={styles.container}>
      {/* Animated Background */}
      <div className={styles.background}>
        <div 
          className={styles.gradientOrb}
          style={{
            transform: `translate(${mousePosition.x * 0.05}%, ${mousePosition.y * 0.05}%)`
          }}
        />
        <div 
          className={styles.gradientOrb2}
          style={{
            transform: `translate(${-mousePosition.x * 0.03}%, ${-mousePosition.y * 0.03}%)`
          }}
        />
        <div 
          className={styles.gradientOrb3}
          style={{
            transform: `translate(${mousePosition.x * 0.02}%, ${-mousePosition.y * 0.04}%)`
          }}
        />
      </div>

      {/* Floating Particles */}
      <div className={styles.particlesContainer}>
        {particles.map(particle => (
          <div
            key={particle.id}
            className={styles.particle}
            style={{
              left: `${particle.x}%`,
              top: `${particle.y}%`,
              width: `${particle.size}px`,
              height: `${particle.size}px`,
              animation: `float ${particle.duration}s infinite ease-in-out ${particle.delay}s`
            }}
          />
        ))}
      </div>

      <div className={styles.content}>
        {/* Header */}
        <header className={styles.header}>
          <div className={styles.titleSection}>
            <div className={styles.iconWrapper}>
              <Calendar className={styles.calendarIcon} />
              <Sparkles className={styles.sparkleIcon} />
            </div>
            <div>
              <h1 className={styles.title}>Custom Calendar 2026</h1>
              <p className={styles.subtitle}>Your Year, Beautifully Organized</p>
            </div>
          </div>
          <button onClick={handleDownloadPDF} className={styles.downloadBtn}>
            <Download className={styles.downloadIcon} />
            <span>Download Complete PDF</span>
          </button>
        </header>

        {/* Months Grid */}
        <div className={styles.monthsGrid}>
          {months.map((month, index) => (
            <div
              key={month.name}
              className={styles.monthCard}
              style={{
                animationDelay: `${index * 0.1}s`
              }}
              onClick={() => setSelectedMonth(month)}
            >
              <div className={styles.monthImageWrapper}>
                <div
                  className={styles.monthImage}
                  style={{
                    backgroundImage: `url(${month.image})`
                  }}
                />

                <div className={styles.shimmer} />
              </div>

            </div>
          ))}
        </div>

        {/* Popup Modal */}
        {selectedMonth && (
          <div className={styles.modalOverlay} onClick={() => setSelectedMonth(null)}>
            <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
              <button className={styles.closeBtn} onClick={() => setSelectedMonth(null)}>
                ×
              </button>
              <img
                src={selectedMonth.image}
                alt={`${selectedMonth.name} 2026`}
                className={styles.modalImage}
              />
            </div>
          </div>
        )}
      </div>
      </div>
      {!selectedMonth && <Footer mode={mode} />}


    </>
  );
};



export default CalendarPage;